import React from "react";

import { SkeletonBar } from "./SkeletonBar";

export const SellerTitle: React.FC<{ name?: string; loading: boolean }> = ({
  name,
  loading,
}) => {
  if (loading)
    return <SkeletonBar className="h-7 w-56" label="Loading seller" />;
  return <>{name ? `Seller: ${name}` : "Seller"}</>;
};
